import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useClaim } from "../../../context/ClaimContext";
import ClaimSuccessModal from "./SupportSuccessModal";
import config from "../../../config/config";
import {
  FaExclamationCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaArrowLeft,
  FaLock,
  FaRedo,
} from "react-icons/fa";
import { SlEqualizer } from "react-icons/sl";
import { useMediaQuery } from "react-responsive";
import { IoMdClose } from "react-icons/io";
import axiosInstance from "../../../AxiosInstance";
import { useUser } from "../../../context/UserContext";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDateString } from "../../../util_functions/helpers";
import { calculateHours } from "../../../util_functions/helpers";
import { RotatingLines, Hourglass } from "react-loader-spinner";

const SupportHoursClaimComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { claimId } = useParams();
  const { fetchClientUserCustomerId } = useUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(1);
  const [isUserChangedItemsPerPage, setIsUserChangedItemsPerPage] =
    useState(false);
  const {
    claimsData,
    fetchClaimById,
    fetchAllClaims,
    triggerFetch,
    fetchTimeLeftByClaimId,
  } = useClaim();
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [filterWorkerName, setFilterWorkerName] = useState("");
  const [filterClientName, setFilterClientName] = useState("");
  const [filterSupportStartDate, setFilterSupportStartDate] = useState(null);
  const [filterSupportEndDate, setFilterSupportEndDate] = useState(null);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterInvoiceStatus, setFilterInvoiceStatus] = useState("");
  const [filterInvoiceSent, setFilterInvoiceSent] = useState("");
  const [selectedClaims, setSelectedClaims] = useState([]);
  const [allClaims, setAllClaims] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isFinalized, setIsFinalized] = useState(false);
  const [isInvoiceGenerated, setIsInvoiceGenerated] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isGeneratingInvoices, setIsGeneratingInvoices] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [areAllRowsDisabled, setAreAllRowsDisabled] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isGenerateInvoiceVisible, setIsGenerateInvoiceVisible] =
    useState(false);

  const [loading, setLoading] = useState(true);

  const containerRef = useRef(null);

  const baseURL = config.API_BASE_URL;

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [showFilter, setShowFilter] = useState(false);

  const isGrid = useMediaQuery({
    query: "(min-width: 320px) and (max-width: 1024px)",
  });

  const isSmallScreen = useMediaQuery({
    query: "(min-width: 320px) and (max-width: 768px)",
  });

  const mainContainerRef = useRef(null);
  const filterRef = useRef(null);
  const tableRef = useRef(null);
  const timesheetsTableRef = useRef(null);
  const tableRowRef = useRef(null);
  const paginationRef = useRef(null);

  const gridContainerRef = useRef(null);
  const gridItemRef = useRef(null);

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        await fetchAllClaims();
      } catch (error) {
        console.error("Error fetching claims:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchClaims();

    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        console.log("Tab is now visible, fetching data...");
        fetchAllClaims();
        console.log("Fetching claims...");
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [location, claimId, triggerFetch, fetchAllClaims]);

  useEffect(() => {
    const handlePopState = () => {
      setIsModalOpen(false);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    if (claimId) {
      setIsModalOpen(true);
      const selectedClaim = allClaims.find(
        (claim) => claim.claimId === claimId
      );
      setSelectedClaim(selectedClaim);
    } else {
      setIsModalOpen(false);
      setSelectedClaim(null);
    }
  }, [claimId, allClaims]);

  useEffect(() => {
    if (claimId && claimsData.length > 0) {
      const claim = claimsData.find((claim) => claim.claimId === claimId);
      if (claim) {
        setSelectedClaim(claim);
        setIsModalOpen(true);
        setIsFinalized(claim.finalized);
        if (claim.timeLeft) {
          setTimeLeft(claim.timeLeft);
        }
      }
    }
  }, [claimId, claimsData]);

  useLayoutEffect(() => {
    function logHeights() {
      const fullHeight = window.innerHeight;
      const tabsHeight = 58;
      const remainingHeight = fullHeight - tabsHeight;

      const filterHeight = filterRef.current?.offsetHeight;
      const paginationHeight = paginationRef.current?.offsetHeight;
      const heightWithNoTabsAndFilter = remainingHeight - filterHeight;
      const tableRowHeight = tableRowRef.current?.offsetHeight;
      const itemsPerPageHeight =
        remainingHeight - filterHeight - paginationHeight;
      const itemsPerPageWidth = gridContainerRef.current?.offsetWidth;

      console.log("Total browser viewport height:", fullHeight, "px");
      console.log("Tabs height:", tabsHeight, "px");
      console.log("filter-overall-container height:", filterHeight);
      console.log(
        "Remaining height without tabs and filter:",
        heightWithNoTabsAndFilter,
        "px"
      );
      console.log("pagination height:", paginationHeight);
      console.log("Table row height:", tableRowHeight, "px");

      if (isGrid) {
        console.log("Is Grid", isGrid);
        console.log("Timesheets table ref width:", itemsPerPageWidth, "px");
        const containerWidth = itemsPerPageWidth;
        const gridItemWidth = gridItemRef.current?.offsetWidth;
        const gridItemHeight = gridItemRef.current?.offsetHeight;

        if (containerWidth && gridItemWidth && gridItemHeight) {
          const columns = Math.floor(containerWidth / gridItemWidth);
          const rows = Math.floor(remainingHeight / gridItemHeight);
          const computed = columns * rows;
          console.log(
            "[updateItemsPerPage - Grid] columns:",
            columns,
            "rows:",
            rows
          );
        }
      }

      console.log(
        "available items per page height no tabs, filter, pagination:",
        itemsPerPageHeight,
        "px"
      );
    }

    logHeights();

    window.addEventListener("resize", logHeights);

    return () => {
      window.removeEventListener("resize", logHeights);
    };
  }, [isGrid]);

  const updateItemsPerPage = useCallback(() => {
    if (isUserChangedItemsPerPage) {
      return;
    }
    const fullHeight = window.innerHeight;
    const tabsHeight = 58;
    const remainingHeight = fullHeight - tabsHeight;

    if (isGrid) {
      const containerWidth = gridContainerRef.current?.offsetWidth;
      const gridItemWidth = gridItemRef.current?.offsetWidth;
      const gridItemHeight = gridItemRef.current?.offsetHeight;

      if (containerWidth && gridItemWidth && gridItemHeight) {
        const columns = Math.floor(containerWidth / gridItemWidth);
        const rows = Math.floor(remainingHeight / gridItemHeight);
        const computed = columns * rows;
        console.log(
          "[updateItemsPerPage - Grid] columns:",
          columns,
          "rows:",
          rows
        );
        setItemsPerPage(computed >= 1 ? computed : 1);
      } else {
        console.log(
          "[updateItemsPerPage - Grid] missing dimensions, defaulting to 1"
        );
        setItemsPerPage(1);
      }
    } else {
      const filterHeight = filterRef.current?.offsetHeight;
      const paginationHeight = paginationRef.current?.offsetHeight;
      const itemsPerPageHeight =
        (remainingHeight - filterHeight - paginationHeight) * 0.65;
      const rowHeight = tableRowRef.current?.offsetHeight;
      if (rowHeight) {
        const computed = Math.floor(itemsPerPageHeight / rowHeight);
        console.log("[updateItemsPerPage - Table] computed rows:", computed);
        setItemsPerPage(computed >= 1 ? computed : 1);
      } else {
        console.log(
          "[updateItemsPerPage - Table] rowHeight undefined, defaulting to 1"
        );
        setItemsPerPage(1);
      }
    }
  }, [isGrid]);

  const filteredClaims = useMemo(() => {
    return claimsData.filter((claim) => {
      if (
        !claim.claimId ||
        !claim.clientName ||
        !claim.workerName ||
        !claim.startDate ||
        !claim.startTime ||
        !claim.endTime ||
        !claim.rate ||
        typeof claim.rate.value !== "number" ||
        !claim.rate.type ||
        !claim.rate.type.trim()
      ) {
        return false;
      }

      const matchesClientName = filterClientName
        ? claim.clientName
            .toLowerCase()
            .includes(filterClientName.toLowerCase())
        : true;

      const matchesSupportDate =
        filterSupportStartDate || filterSupportEndDate
          ? moment(claim.startDate).isBetween(
              filterSupportStartDate,
              filterSupportEndDate,
              undefined,
              "[]"
            )
          : true;

      const matchesStatus = filterStatus ? claim.status === filterStatus : true;

      const matchesInvoiceStatus =
        filterInvoiceStatus === "true"
          ? claim.invoiceSent === true
          : filterInvoiceStatus === "false"
          ? claim.invoiceSent === false
          : true;

      return (
        matchesClientName &&
        matchesSupportDate &&
        matchesStatus &&
        matchesInvoiceStatus
      );
    });
  }, [
    claimsData,
    filterClientName,
    filterSupportStartDate,
    filterSupportEndDate,
    filterStatus,
    filterInvoiceStatus,
  ]);

  const firstItemIndex = (currentPage - 1) * itemsPerPage;
  const lastItemIndex = firstItemIndex + itemsPerPage;
  const currentItems = filteredClaims.slice(firstItemIndex, lastItemIndex);

  const totalPages = Math.ceil(filteredClaims.length / itemsPerPage);

  useEffect(() => {
    console.log("Claims data:", claimsData);
  }, [claimsData]);

  useEffect(() => {
    console.log("currentItems:", currentItems);
  }, [currentItems]);

  useEffect(() => {
    console.log("Filtered items count:", filteredClaims.length);
    console.log("Filtered items:", filteredClaims);
  }, [filteredClaims]);

  useLayoutEffect(() => {
    const updateLayout = () => {
      if (isGrid) {
        if (gridItemRef.current && gridItemRef.current.offsetHeight) {
          updateItemsPerPage();
        } else {
          requestAnimationFrame(updateLayout);
        }
      } else {
        if (tableRowRef.current && tableRowRef.current.offsetHeight) {
          updateItemsPerPage();
        } else {
          requestAnimationFrame(updateLayout);
        }
      }
    };

    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, [filteredClaims, isGrid, updateItemsPerPage]);

  const generateDropdownOptions = () => {
    let base = itemsPerPage;
    let secondOption = Math.ceil((base * 2) / 5) * 5;
    return [base, secondOption, secondOption * 2].filter(
      (value, index, self) => self.indexOf(value) === index
    );
  };

  const dropdownOptions = generateDropdownOptions();

  const handleViewMore = async (claimId) => {
    const claim = await fetchClaimById(claimId);
    if (!claim) {
      console.error("Failed to fetch claim.");
      return;
    }

    setSelectedClaim(claim);
    setIsModalOpen(true);
    navigate(
      `/account/admin-dashboard/billing-invoicing/timesheets/details/${claimId}`
    );
    const timeLeftData = await fetchTimeLeftByClaimId(claimId);
    console.log("View More Time Left : ", timeLeftData);
    setTimeLeft(timeLeftData);
    try {
      const customerUser = await fetchClientUserCustomerId(claim.clientId);
      console.log("Customer User Details:", customerUser);
      const customerId =
        customerUser.paymentDetails.paymentIntentDetails.customerId;
      console.log("Customer ID:", customerId);

      if (!customerId) {
        console.error("Customer ID not available");
      }
    } catch (error) {
      console.error("Error fetching client user customer ID:", error);
    }

    console.log("Selected Claim Details:", claim);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const localDate = new Date(
      date.getTime() + date.getTimezoneOffset() * 60000
    );
    return localDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const formatHours = (hours) => {
    const hrs = Math.floor(hours);
    const mins = Math.round((hours - hrs) * 60);

    let result = "";

    if (hrs > 0) {
      result += `${hrs} ${hrs === 1 ? "hr" : "hrs"}`;
    }

    if (mins > 0) {
      if (result) result += ", ";
      result += `${mins} ${mins === 1 ? "min" : "mins"}`;
    }

    return result || "0 mins";
  };

  const calculateHours = (startTime, endTime) => {
    if (!startTime || !endTime) {
      return "N/A";
    }
    const parseTime = (timeStr) => {
      if (!timeStr) {
        return { hours: 0, minutes: 0 };
      }
      const [time, modifier] = timeStr.split(" ");
      let [hours, minutes] = time.split(":");
      if (hours === "12") {
        hours = "00";
      }
      if (modifier === "PM") {
        hours = parseInt(hours, 10) + 12;
      } else {
        hours = parseInt(hours, 10);
      }
      minutes = parseInt(minutes, 10);
      return { hours, minutes };
    };

    const start = parseTime(startTime);
    const end = parseTime(endTime);

    const startDate = new Date(0, 0, 0, start.hours, start.minutes);
    const endDate = new Date(0, 0, 0, end.hours, end.minutes);

    let diff = (endDate - startDate) / 1000 / 60 / 60;
    if (diff < 0) {
      diff += 24;
    }

    return diff.toFixed(2);
  };

  const renderRates = (rate) => {
    if (!rate)
      return (
        <>
          <td>No rate value</td>
          <td>No rate type</td>
        </>
      );
    return (
      <>
        <td>
          <strong>${rate.value.toFixed(2)}</strong>
        </td>
        <td>{rate.type}</td>
      </>
    );
  };

  const handleModalClose = () => {
    setShowModal(false);
    navigate(`/account/admin-dashboard/billing-invoicing/timesheets`);
  };

  const handleBackClick = () => {
    setShowModal(false);
    navigate(`/account/admin-dashboard/billing-invoicing/timesheets`);
  };

  const handleWorkerNameFilterChange = (e) => {
    setFilterWorkerName(e.target.value);
    setIsFilterApplied(true);
  };

  const handleClientNameFilterChange = (e) => {
    setFilterClientName(e.target.value);
  };

  const handleSupportStartDateChange = (date) => {
    setFilterSupportStartDate(date);
  };

  const handleSupportEndDateChange = (date) => {
    setFilterSupportEndDate(date);
  };

  const handleStatusFilterChange = (e) => {
    setFilterStatus(e.target.value);
  };

  const handleInvoiceStatusFilterChange = (e) => {
    const value = e.target.value;
    setFilterInvoiceStatus(value);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setIsUserChangedItemsPerPage(true);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setFilterWorkerName("");
    setFilterSupportStartDate(null);
    setFilterSupportEndDate(null);
    setFilterStatus("");
    setFilterInvoiceSent("");
    setIsFilterApplied(false);
    setSelectedClaims([]);
  };

  const createInvoiceObject = (customerId, customerEmail, claim) => {
    const amountInCents = Math.round(claim.totalAmountDue * 100);
    const description = `Invoice for Claim Reference# ${claim.claimId}`;
    return {
      customerId: customerId,
      accountId: claim.paymentAccount,
      amount: amountInCents,
      currency: "usd",
      description: description,
      clientId: claim.clientId,
      workerId: claim.userId,
      clientName: claim.clientName,
      workerName: claim.workerName,
      claimReferenceNumber: claim.claimId,
      agreementReferenceNumber: claim.agreementId,
      invoiceDescription: description,
    };
  };

  const handleSelectAll = () => {
    setIsAllSelected((prev) => {
      const newIsAllSelected = !prev;

      if (newIsAllSelected) {
        const allSelectableClaims = filteredClaims
          .filter((claim) => {
            const isDisabled =
              (claim.status === "Approved" && claim.invoiceSent) ||
              (claim.status === "Pending" && !claim.invoiceSent);
            return !isDisabled;
          })
          .map((claim) => claim.claimId);

        setSelectedClaims(allSelectableClaims);

        const fetchAndLogInvoices = async () => {
          const invoices = await Promise.all(
            allSelectableClaims.map(async (claimId) => {
              const claim = claimsData.find(
                (claim) => claim.claimId === claimId
              );
              if (claim) {
                const customerUser = await fetchClientUserCustomerId(
                  claim.clientId
                );
                const customerId =
                  customerUser.paymentDetails.paymentIntentDetails.customerId;
                const customerEmail = customerUser.email;
                return createInvoiceObject(customerId, customerEmail, claim);
              }
              return null;
            })
          );
          console.log(
            "All Selected Invoice Objects:",
            invoices.filter((invoice) => invoice !== null)
          );
        };

        fetchAndLogInvoices();
      } else {
        setSelectedClaims([]);
        logSelectedClaims([]);
      }

      return newIsAllSelected;
    });
  };

  const handleSelectClaim = async (claimId) => {
    const claim = claimsData.find((claim) => claim.claimId === claimId);
    const isDisabled =
      (claim.status === "Approved" && claim.invoiceSent) ||
      (claim.status === "Approved" && !claim.finalized) ||
      (claim.status === "Pending" && !claim.invoiceSent);

    setSelectedClaims((prevSelectedClaims) => {
      const isAlreadySelected = prevSelectedClaims.includes(claimId);
      const newSelectedClaims = isAlreadySelected
        ? prevSelectedClaims.filter((id) => id !== claimId)
        : isDisabled
        ? prevSelectedClaims
        : [...prevSelectedClaims, claimId];

      const fetchAndLogInvoices = async () => {
        const invoices = await Promise.all(
          newSelectedClaims.map(async (claimId) => {
            const claim = claimsData.find((claim) => claim.claimId === claimId);
            if (claim) {
              const customerUser = await fetchClientUserCustomerId(
                claim.clientId
              );
              const customerId =
                customerUser.paymentDetails.paymentIntentDetails.customerId;
              const customerEmail = customerUser.email;
              return createInvoiceObject(customerId, customerEmail, claim);
            }
            return null;
          })
        );
        console.log(
          "Selected Invoice Objects:",
          invoices.filter((invoice) => invoice !== null)
        );
      };

      fetchAndLogInvoices();

      return newSelectedClaims;
    });
  };

  const logSelectedClaims = (
    selectedClaims,
    customerId = null,
    selectedClaim = null
  ) => {
    const selectedClaimsDetails = claimsData.filter((claim) =>
      selectedClaims.includes(claim.claimId)
    );

    if (customerId && selectedClaim) {
      const invoice = createInvoiceObject(customerId, selectedClaim);
      console.log("Invoice Object:", invoice);
    } else {
      console.log("All Selected Claims Details:", selectedClaimsDetails);
    }
  };

  const handleGenerateSelectedInvoices = async () => {
    setSuccessMessage("");
    setIsGeneratingInvoices(true);
    for (const claimId of selectedClaims) {
      const claim = claimsData.find((claim) => claim.claimId === claimId);
      if (claim) {
        console.log(`Generating invoice for: ${claimId}`);
        await generateInvoice(claim);
        setProgress(
          (prevProgress) => prevProgress + 100 / selectedClaims.length
        );
      }
    }
    setSelectedClaims([]);
  };

  const generateInvoice = async (selectedClaim) => {
    const smoothScrollToTop = () => {
      const element = containerRef.current;
      if (element) {
        const scrollDuration = 600;
        const scrollStep = -element.scrollTop / (scrollDuration / 15);
        const scrollInterval = setInterval(() => {
          if (element.scrollTop !== 0) {
            element.scrollTop += scrollStep;
          } else {
            clearInterval(scrollInterval);
          }
        }, 15);
      }
    };

    try {
      smoothScrollToTop();
      setIsGeneratingInvoices(true);
      setSuccessMessage("Fetching customer details...");
      setProgress(20);
      const customerUser = await fetchClientUserCustomerId(
        selectedClaim.clientId
      );
      const customerId =
        customerUser.paymentDetails.paymentIntentDetails.customerId;
      const customerEmail = customerUser.email;

      if (!customerId) {
        console.error("Customer ID not available");
        setIsGeneratingInvoices(false);
        return;
      }

      const amountInCents = Math.round(selectedClaim.totalAmountDue * 100);
      setSuccessMessage("Creating invoice...");
      setProgress(40);

      const description = `Invoice for Claim Reference# ${selectedClaim.claimId}`;

      const createResponse = await axiosInstance.post(
        `${baseURL}/v1/stripe/create-invoice`,
        {
          customerId: customerId,
          accountId: selectedClaim.paymentAccount,
          amount: amountInCents,
          currency: "usd",
          description: description,
          clientId: selectedClaim.clientId,
          workerId: selectedClaim.userId,
          clientName: selectedClaim.clientName,
          workerName: selectedClaim.workerName,
          claimReferenceNumber: selectedClaim.claimId,
          agreementReferenceNumber: selectedClaim.agreementId,
          invoiceDescription: description,
        }
      );

      setSuccessMessage("Invoice created. Finalizing...");
      setProgress(60);

      if (createResponse.data && createResponse.data.success) {
        const invoiceId = createResponse.data.invoiceId;

        const finalizeResponse = await axiosInstance.post(
          `${baseURL}/v1/stripe/finalize-invoice`,
          {
            invoiceId: invoiceId,
            claimId: selectedClaim.claimId,
          }
        );

        setSuccessMessage("Finalizing invoice...");
        setProgress(80);

        if (finalizeResponse.data && finalizeResponse.data.success) {
          try {
            const finalizedInvoiceData = finalizeResponse.data;
            const invoiceDetails = {
              success: finalizedInvoiceData.success,
              invoiceId: invoiceId,
              claimReferenceNumber: selectedClaim.claimId,
              agreementReferenceNumber: selectedClaim.agreementId,
              created: finalizedInvoiceData.created,
              customerId: customerId,
              customerEmail: customerEmail,
              amountDue: amountInCents,
              clientId: selectedClaim.clientId,
              workerId: selectedClaim.userId,
              clientName: selectedClaim.clientName,
              workerName: selectedClaim.workerName,
              currency: finalizedInvoiceData.currency,
              status: finalizedInvoiceData.status,
              finalizedAt: finalizedInvoiceData.finalizedAt,
              paidAt: finalizedInvoiceData.paidAt,
              hostedInvoiceUrl: finalizedInvoiceData.hostedInvoiceUrl,
              paymentStatus: finalizedInvoiceData.paymentStatus,
              description: `Invoice for Claim Reference# ${selectedClaim.claimId}`,
              invoiceSent: false,
              invoicePaid: false,
            };

            const saveInvoiceResponse = await axiosInstance.post(
              `${baseURL}/v1/invoices`,
              invoiceDetails
            );

            setSuccessMessage("Saving invoice...");
            setProgress(90);

            if (saveInvoiceResponse.data && saveInvoiceResponse.data.success) {
              setIsInvoiceGenerated(true);
              setSuccessMessage("Invoice successfully generated.");
              console.log(
                "Invoice saved successfully:",
                saveInvoiceResponse.data
              );

              const patchInvoiceResponse = await axiosInstance.patch(
                `${baseURL}/v1/invoices/${invoiceId}`,
                { caseType: "invoice_sent" }
              );

              if (
                patchInvoiceResponse.data &&
                patchInvoiceResponse.data.success
              ) {
                console.log("Invoice marked as sent successfully");

                await axiosInstance.patch(
                  `${baseURL}/v1/claims/${selectedClaim.claimId}`,
                  {
                    caseType: "generate_invoice",
                  }
                );
              } else {
                console.error(
                  "Failed to mark invoice as sent:",
                  patchInvoiceResponse.data
                );
              }
            } else {
              console.error(
                "Failed to save invoice:",
                saveInvoiceResponse.data
              );
            }
          } catch (saveError) {
            console.error("Error during saving invoice:", saveError);
            if (saveError.response) {
              console.error(
                "Save Invoice Response Error Data:",
                saveError.response.data
              );
              console.error(
                "Save Invoice Response Status:",
                saveError.response.status
              );
              console.error(
                "Save Invoice Response Headers:",
                saveError.response.headers
              );
            }
          }
        } else {
          console.error("Failed to finalize invoice:", finalizeResponse.data);
        }
      } else {
        console.error("Failed to create invoice:", createResponse.data);
      }
      setProgress(100);
    } catch (error) {
      console.error("Error during invoice creation or finalization:", error);
    } finally {
      setTimeout(() => {
        setProgress(0);
        setIsGeneratingInvoices(false);
      }, 1500);
    }
  };

  useEffect(() => {
    const allDisabled = filteredClaims.every((claim) => {
      const isDisabled =
        (claim.status === "Approved" && claim.invoiceSent) ||
        (claim.status === "Approved" && !claim.finalized) ||
        (claim.status === "Pending" && !claim.invoiceSent);
      return isDisabled;
    });
    setAreAllRowsDisabled(allDisabled);
  }, [filteredClaims]);

  const handleOpenForEditing = async (claim) => {
    try {
      const response = await axiosInstance.patch(
        `${config.API_BASE_URL}/v1/claims/${claim.claimId}`,
        { caseType: "open_for_editing" }
      );
      if (response.data) {
        setSelectedClaim((prevClaim) => ({
          ...prevClaim,
          isAllowedEdit: true,
        }));
        fetchAllClaims();
      } else {
        console.error("Failed to set claim as editable:", response);
      }
    } catch (error) {
      console.error("Error setting claim to editable:", error);
    }
  };

  const handleClose = () => {
    setSuccessMessage("");
  };

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  const handlePageChange = (action) => {
    switch (action) {
      case "first":
        setCurrentPage(1);
        break;
      case "previous":
        setCurrentPage((prev) => Math.max(prev - 1, 1));
        break;
      case "next":
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
        break;
      case "last":
        setCurrentPage(totalPages);
        break;
      default:
        break;
    }
  };

  return (
    <div ref={mainContainerRef} className="adminsupportclaim-support-container">
      {successMessage && (
        <div className="claim-success-message">
          <FaCheckCircle className="invoice-check-icon" />
          <h4>{successMessage}</h4>
          <IoMdClose className="success-message-close" onClick={handleClose} />
        </div>
      )}
      {(isGeneratingInvoices || progress > 0) && (
        <div className="invoice-success-progress-bar">
          <div
            className="invoice-success-progress-bar-inner"
            style={{ width: `${progress}%` }}
          >
            {progress.toFixed(0)}%
          </div>
        </div>
      )}
      {showModal && <ClaimSuccessModal onClose={handleModalClose} />}
      <div className="supportclaim-header">
        {!isModalOpen && (
          <>
            {isMobile && (
              <div className="filter-toggle-container" onClick={toggleFilter}>
                {showFilter ? (
                  <div className="filter-hide">
                    <FaTimesCircle />
                  </div>
                ) : (
                  <div className="filter-show">
                    <SlEqualizer className="filter-toggle-icon" />
                    <span>Show Filters</span>
                  </div>
                )}
              </div>
            )}
            {(showFilter || !isMobile) && (
              <div ref={filterRef} className="filter-overall-container">
                <div className="wclaim-filter-container">
                  <div className="wclaim-filter-noaddnew-container">
                    <div className="filter-wn-dateselects">
                      <div className="claim-filter-itemwn">
                        <label htmlFor="client-name-filter">
                          Filter by Client/Worker
                        </label>
                        <input
                          id="client-name-filter"
                          type="text"
                          placeholder="Client or worker name ..."
                          value={filterClientName}
                          onChange={handleClientNameFilterChange}
                        />
                      </div>
                      <div className="claim-filter-itemds">
                        <label>Date Range</label>
                        <div className="claim-date-selects">
                          <DatePicker
                            selected={filterSupportStartDate}
                            onChange={handleSupportStartDateChange}
                            selectsStart
                            startDate={filterSupportStartDate}
                            endDate={filterSupportEndDate}
                            placeholderText="Start date"
                          />
                          <DatePicker
                            selected={filterSupportEndDate}
                            onChange={handleSupportEndDateChange}
                            selectsEnd
                            startDate={filterSupportStartDate}
                            endDate={filterSupportEndDate}
                            minDate={filterSupportStartDate}
                            placeholderText="End date"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="status-claim-clear-container">
                      <div className="status-claim-status-container">
                        <div className="claim-filter-itemst">
                          <label htmlFor="status-filter">Claim Status</label>
                          <select
                            id="status-filter"
                            value={filterStatus}
                            onChange={handleStatusFilterChange}
                          >
                            <option value="">All</option>
                            <option value="Pending">Pending</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                          </select>
                        </div>
                        <div className="claim-filter-itemst">
                          <label htmlFor="invoice-status-filter">
                            Invoice Status
                          </label>
                          <select
                            id="invoice-status-filter"
                            value={filterInvoiceStatus}
                            onChange={handleInvoiceStatusFilterChange}
                          >
                            <option value="">All</option>
                            <option value="true">Sent</option>
                            <option value="false">Not Sent</option>
                          </select>
                        </div>
                      </div>
                      <div className="clear-filters-container">
                        <button
                          className="timesheet-clear-filters-button"
                          onClick={handleClearFilters}
                        >
                          <FaRedo className="timesheet-filter-reset" />
                          Clear Filters
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {loading ? (
        <div className="loading-spinner">
          <RotatingLines
            visible={true}
            height="96"
            width="56"
            color="grey"
            strokeWidth="3"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : filteredClaims.length === 0 ? (
        <div ref={tableRef} className="no-claims-message">
          <p>No claims submitted yet ...</p>
        </div>
      ) : (
        !isModalOpen &&
        !selectedClaim && (
          <div
            ref={isGrid ? gridContainerRef : timesheetsTableRef}
            className="timesheets-table"
          >
            {isGrid ? (
              <div className="timesheet-grid-wrapper">
                {currentItems.map((item, index) => {
                  const hours = calculateHours(item.startTime, item.endTime);
                  const amountDue = item.rate ? item.rate.value * hours : 0;
                  return (
                    <div
                      key={item.id || index}
                      ref={index === 0 ? gridItemRef : null}
                      className="timesheet-grid-item"
                    >
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">Client</span>
                        <span className="timesheet-grid-value">
                          <strong>{item.clientName}</strong>
                        </span>
                      </div>
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">
                          Support date
                        </span>
                        <span className="timesheet-grid-value">
                          {formatDate(item.startDate)}
                        </span>
                      </div>
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">
                          Session time
                        </span>
                        <span className="timesheet-grid-value">{`${item.startTime} - ${item.endTime}`}</span>
                      </div>
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">Hours</span>
                        <span className="grid-value">
                          <strong>{formatHours(hours)}</strong>
                        </span>
                      </div>
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">
                          Rate / Hour
                        </span>
                        <span className="timesheet-grid-value">
                          <strong>
                            {item.rate
                              ? `$${item.rate.value.toFixed(2)}`
                              : "N/A"}
                          </strong>
                        </span>
                      </div>
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">Schedule</span>
                        <span className="timesheet-grid-value">
                          {item.rate ? item.rate.type : "No rate type"}
                        </span>
                      </div>
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">
                          Session amount
                        </span>
                        <span className="timesheet-grid-value">
                          <strong>${amountDue.toFixed(2)}</strong>
                        </span>
                      </div>
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">
                          Claim status
                        </span>
                        <span className="timesheet-grid-value">
                          <div className="timesheet-claim-status-container">
                            {item.status}
                            {item.status === "Pending" ? (
                              <FaExclamationCircle className="claim-status-pending" />
                            ) : item.status === "Rejected" ? (
                              <FaTimesCircle className="claim-status-rejected" />
                            ) : (
                              <FaCheckCircle className="grid-claim-status-completed" />
                            )}
                          </div>
                        </span>
                      </div>
                      <div className="timesheet-grid-field">
                        <span className="timesheet-grid-label">
                          Invoice sent
                        </span>
                        <span className="timesheet-grid-value">
                          <strong
                            className={
                              item.invoiceSent ? "grid-yes-text" : "no-text"
                            }
                          >
                            {item.invoiceSent ? "Yes" : "No"}
                          </strong>
                        </span>
                      </div>
                      <div className="grid-field">
                        <button
                          className="grid-view-more-button"
                          onClick={() => handleViewMore(item.claimId)}
                        >
                          View more
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div>
                {!isModalOpen && !selectedClaims.length > 0 && (
                  <div className="generate-selected-invoices-container">
                    <button
                      className="generate-selected-invoices-button"
                      onClick={handleGenerateSelectedInvoices}
                      disabled={selectedClaims.some((claimId) => {
                        const claim = claimsData.find(
                          (claim) => claim.claimId === claimId
                        );
                        return claim.invoiceSent && claim.finalized;
                      })}
                    >
                      Generate Invoices for Selected
                    </button>
                    {selectedClaims.some((claimId) => {
                      const claim = claimsData.find(
                        (claim) => claim.claimId === claimId
                      );
                      return claim.invoiceSent && claim.finalized;
                    }) && (
                      <p>
                        Only unbilled and unfinalized claims can be invoiced.
                      </p>
                    )}
                  </div>
                )}
                <table
                  className={`supportclaim-support-table ${
                    isModalOpen ? "hidden" : ""
                  }`}
                >
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                          disabled={areAllRowsDisabled}
                        />
                      </th>
                      <th>Worker</th>
                      <th>Support date</th>
                      <th>Session time</th>
                      <th>Hours</th>
                      <th>Rate / Hour</th>
                      <th>Schedule</th>
                      <th>Amount</th>
                      <th>Claim Status</th>
                      <th>Billed</th>
                      <th>View More</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((item, index) => {
                      const hours = calculateHours(
                        item.startTime,
                        item.endTime
                      );
                      const amountDue = item.rate ? item.rate.value * hours : 0;

                      const isDisabled =
                        (item.status === "Approved" && item.invoiceSent) ||
                        (item.status === "Approved" && !item.finalized) ||
                        (item.status === "Pending" && !item.invoiceSent);

                      return (
                        <tr
                          key={item.id || index}
                          ref={index === 0 ? tableRowRef : null}
                        >
                          <td>
                            <input
                              id={`checkbox-${item.claimId}`}
                              type="checkbox"
                              checked={selectedClaims.includes(item.claimId)}
                              onChange={() => handleSelectClaim(item.claimId)}
                              disabled={isDisabled}
                            />
                          </td>
                          <td className="client-name-cell">
                            {item.workerName}
                          </td>
                          <td>{formatDate(item.startDate)}</td>
                          <td>{`${item.startTime} - ${item.endTime}`}</td>
                          <td>{hours}</td>
                          {renderRates(item.rate)}
                          <td>
                            <strong>${amountDue.toFixed(2)}</strong>
                          </td>
                          <td>
                            {item.status}
                            {item.status === "Pending" ? (
                              <FaExclamationCircle className="claim-status-pending" />
                            ) : item.status === "Rejected" ? (
                              <FaTimesCircle className="claim-status-rejected" />
                            ) : (
                              <FaCheckCircle className="claim-status-completed" />
                            )}
                          </td>
                          <td className="invoice-sent-style">
                            <strong
                              className={
                                item.invoiceSent ? "yes-text" : "no-text"
                              }
                            >
                              {item.invoiceSent ? "Yes" : "No"}
                            </strong>
                          </td>
                          <td className="invoice-sent-style">
                            <button
                              className="view-more-button"
                              onClick={() => handleViewMore(item.claimId)}
                            >
                              View more
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {!isModalOpen && !selectedClaim && (
              <div className="items-per-page-selector">
                <label htmlFor="items-per-page">Show items per page</label>
                <select
                  id="items-per-page"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  {dropdownOptions.map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {!isModalOpen && (
              <div ref={paginationRef} className="active-jobs-pagination">
                <button
                  onClick={() => handlePageChange("first")}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
                <button
                  onClick={() => handlePageChange("previous")}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>
                <span>
                  Page <strong>{currentPage}</strong> of{" "}
                  <strong>{totalPages > 99 ? "99+" : totalPages}</strong>
                </span>

                <button
                  onClick={() => handlePageChange("next")}
                  disabled={currentPage >= totalPages}
                >
                  &gt;
                </button>
                <button
                  onClick={() => handlePageChange("last")}
                  disabled={currentPage >= totalPages}
                >
                  &raquo;
                </button>
              </div>
            )}
          </div>
        )
      )}
      {isModalOpen &&
        selectedClaim &&
        (() => {
          const hours = calculateHours(
            selectedClaim.startTime,
            selectedClaim.endTime
          );
          return (
            <div className="claim-details">
              <div className="claim-back-container" onClick={handleBackClick}>
                <FaArrowLeft className="claim-back-icon" /> Back to Claims List
              </div>
              {timeLeft && (
                // <div className="claim-time-left">
                //   Worksheet editable for <strong>{timeLeft}</strong>, before
                //   lock.
                // </div>
                <div className="claim-time-left">
                  Worksheet finalized and locked.
                </div>
              )}
              {isSmallScreen ? (
                <div className="timesheets-details-table">
                  <table>
                    <tbody>
                      <tr>
                        <td>Reference Number</td>
                        <td>
                          <strong>{selectedClaim.claimId}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Agreement Ref Number</td>
                        <td>
                          <a
                            href={`/account/ps-dashboard/agreements/worker/${selectedClaim.agreementId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="agreement-link"
                          >
                            {selectedClaim.agreementId}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Claim Submission Date</td>
                        <td>
                          {formatDateString(selectedClaim.claimSubmissionDate)}
                        </td>
                      </tr>
                      <tr>
                        <td>Client Name</td>
                        <td className="agreement-link">
                          {selectedClaim.clientName}
                        </td>
                      </tr>
                      <tr>
                        <td>Support Date</td>
                        <td>
                          <strong>{formatDate(selectedClaim.startDate)}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Worker Name</td>
                        <td className="agreement-link">
                          {selectedClaim.workerName}
                        </td>
                      </tr>
                      <tr>
                        <td>Start Time</td>
                        <td>
                          <strong>{selectedClaim.startTime}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>End Time</td>
                        <td>
                          <strong>{selectedClaim.endTime}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Hours</td>
                        <td>
                          <strong>{formatHours(hours)}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Rate / Hour</td>
                        <td>
                          {selectedClaim.rate ? (
                            <>
                              <strong>
                                ${selectedClaim.rate.value.toFixed(2)}
                              </strong>{" "}
                              ({selectedClaim.rate.type})
                            </>
                          ) : (
                            "No rate"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Claim Status</td>
                        <td>
                          <strong>
                            {selectedClaim.status}
                            {selectedClaim.status === "Pending" ? (
                              <FaExclamationCircle className="claim-status-pending" />
                            ) : selectedClaim.status === "Rejected" ? (
                              <FaTimesCircle className="claim-status-rejected" />
                            ) : (
                              <FaCheckCircle className="claim-status-completed" />
                            )}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Invoice Sent</td>
                        <td>
                          <strong>
                            {selectedClaim.invoiceSent ? "Yes" : "No"}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Invoice Paid</td>
                        <td>
                          <strong>
                            {selectedClaim.invoicePaid ? "Yes" : "No"}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Session Amount</td>
                        <td>
                          <strong>
                            {selectedClaim.rate
                              ? `$${(
                                  selectedClaim.rate.value *
                                  calculateHours(
                                    selectedClaim.startTime,
                                    selectedClaim.endTime
                                  )
                                ).toFixed(2)}`
                              : "$0.00"}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Meet & Greet Session Rate</td>
                        <td>
                          <strong>
                            ${selectedClaim.initialGreetingSessionRate}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Amount Due</td>
                        <td>
                          <div className="claim-total-amount">
                            {selectedClaim.rate
                              ? `$${(
                                  selectedClaim.rate.value *
                                    calculateHours(
                                      selectedClaim.startTime,
                                      selectedClaim.endTime
                                    ) +
                                  parseFloat(
                                    selectedClaim.initialGreetingSessionRate
                                  )
                                ).toFixed(2)}`
                              : `$${parseFloat(
                                  selectedClaim.initialGreetingSessionRate
                                ).toFixed(2)}`}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="timesheets-details">
                  <div className="details-table-left">
                    <table>
                      <tbody>
                        <tr>
                          <td>Reference Number</td>

                          <td>
                            <strong>{selectedClaim.claimId}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Agreement Ref Number</td>
                          <td>
                            <a
                              href={`/account/ps-dashboard/agreements/worker/${selectedClaim.agreementId}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="agreement-link"
                            >
                              {selectedClaim.agreementId}
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>Claim Submission Date</td>
                          <td>
                            {formatDateString(
                              selectedClaim.claimSubmissionDate
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Client Name</td>
                          <td className="agreement-link">
                            {selectedClaim.clientName}
                          </td>
                        </tr>
                        <tr>
                          <td>Support Date</td>
                          <td>
                            <strong>
                              {formatDate(selectedClaim.startDate)}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Worker Name</td>
                          <td className="agreement-link">
                            {selectedClaim.workerName}
                          </td>
                        </tr>
                        <tr>
                          <td>Start Time</td>
                          <td>
                            <strong>{selectedClaim.startTime}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>End Time</td>
                          <td>
                            <strong>{selectedClaim.endTime}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="details-table-right">
                    <table>
                      <tbody>
                        <tr>
                          <td>Hours</td>
                          <td>
                            <strong>{formatHours(hours)}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Rate / Hour</td>
                          <td>
                            {selectedClaim.rate ? (
                              <>
                                <strong>
                                  ${selectedClaim.rate.value.toFixed(2)}
                                </strong>{" "}
                                ({selectedClaim.rate.type})
                              </>
                            ) : (
                              "No rate"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Claim Status</td>
                          <td>
                            <strong>
                              {selectedClaim.status}
                              {selectedClaim.status === "Pending" ? (
                                <FaExclamationCircle className="claim-status-pending" />
                              ) : selectedClaim.status === "Rejected" ? (
                                <FaTimesCircle className="claim-status-rejected" />
                              ) : (
                                <FaCheckCircle className="claim-status-completed" />
                              )}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Invoice Sent</td>
                          <td>
                            <strong>
                              {selectedClaim.invoiceSent ? "Yes" : "No"}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Invoice Paid</td>
                          <td>
                            <strong>
                              {selectedClaim.invoicePaid ? "Yes" : "No"}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Session Amount</td>
                          <td>
                            <strong>
                              {selectedClaim.rate
                                ? `$${(
                                    selectedClaim.rate.value *
                                    calculateHours(
                                      selectedClaim.startTime,
                                      selectedClaim.endTime
                                    )
                                  ).toFixed(2)}`
                                : "$0.00"}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Meet & Greet Session Rate</td>
                          <td>
                            <strong>
                              ${selectedClaim.initialGreetingSessionRate}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Amount Due</td>
                          <td>
                            <div className="claim-total-amount">
                              {selectedClaim.rate
                                ? `$${(
                                    selectedClaim.rate.value *
                                      calculateHours(
                                        selectedClaim.startTime,
                                        selectedClaim.endTime
                                      ) +
                                    parseFloat(
                                      selectedClaim.initialGreetingSessionRate
                                    )
                                  ).toFixed(2)}`
                                : `$${parseFloat(
                                    selectedClaim.initialGreetingSessionRate
                                  ).toFixed(2)}`}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <div className="edit-button-cell">
                <span className="claim-button-container">
                  <>
                    <button
                      className="claim-approve-button"
                      onClick={() => generateInvoice(selectedClaim)}
                      disabled={
                        selectedClaim.status === "Pending" ||
                        selectedClaim.status === "Rejected" ||
                        !selectedClaim.finalized ||
                        selectedClaim.invoiceSent
                      }
                    >
                      Generate Invoice
                    </button>
                    <button
                      className="claim-allow-button"
                      onClick={() => handleOpenForEditing(selectedClaim)}
                      disabled={
                        selectedClaim.status !== "Approved" ||
                        selectedClaim.isAllowedEdit ||
                        !selectedClaim.isFinalized
                      }
                    >
                      {selectedClaim.isAllowedEdit
                        ? "Editing Enabled"
                        : "Open for Editing"}
                    </button>
                  </>
                </span>
              </div>
            </div>
          );
        })()}
    </div>
  );
};

export default SupportHoursClaimComponent;
